import { Component, h, Host } from '@stencil/core';

@Component({
  tag: 'app-home',
  styleUrl: 'component.css',
  assetsDirs: ['../assets'],
  shadow: true,
})
export class AppHome {
  render() {
    return <Host>
      <section class="intro">
        <div class="body content">
          <img class="hero" src="/assets/developer.webp" width="1024" height="707"
            title="AI Image. Old and new architecture in harmony" />
        </div>
        <div class="heading content box">
          <h2>I'm Anthony</h2>
          <h3 class="aside right"><abbr title="Fullstack Developer, C# .NET/TypeScript">Dev</abbr>, Sussex UK</h3>
        </div>
        <div class="content">
          <p>
            I design and write websites, PWAs, APIs, and services in .NET and TypeScript
          </p>
          <p>
            And I work through my company <a href="https://antix.co.uk" target="_blank" rel="noopener">antix.co.uk</a>
          </p>
        </div>
        <div class="sub-sub-heading content">
          <h4>This is my Blog</h4>
        </div>
      </section>

      <section class="articles">

        <entry-azure-functions-durable-tasks summary />
        <entry-data-is-key summary />
        <entry-the-developer-and-the-ai summary />
        <entry-look-ma-no-hands summary />
        <entry-expert-assignment summary />
        <entry-working-from-home summary />

      </section>
    </Host>;
  }
}
